import { Component, inject } from '@angular/core';
import { ButtonsModule, DialogModule, DialogService, FormFieldModule, IconModule, SlideToggleModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommissionerService } from '@lib/commissioner/commissioner.service';
import { Commissioner, CommissionerSingleResponse, createCommissionerFormGroup, StoreCommissionerRequest } from '@lib/api/models/commissioner';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';

@Component({
    selector: 'app-edit-commissioner-general-information-dialog',
    imports: [
        ButtonsModule,
        DialogModule,
        ErrorPanelComponent,
        FormFieldModule,
        IconModule,
        ReactiveFormsModule,
        SlideToggleModule
    ],
    templateUrl: './edit-commissioner-general-information-dialog.component.html',
    standalone: true,
    styleUrl: './edit-commissioner-general-information-dialog.component.scss'
})
export class EditCommissionerGeneralInformationDialogComponent {
    private readonly _commissionerService = inject(CommissionerService);
    private readonly _snackBar = inject(SnackBarService);

    protected readonly commissioner = inject<Commissioner>(DIALOG_DATA);
    protected readonly commissionerDetailsFormGroup = createCommissionerFormGroup(this.commissioner);
    protected readonly dialogRef = inject<DialogRef>(DialogRef);

    updateCommissionerRequest = new SendableRequest<CommissionerSingleResponse, StoreCommissionerRequest>({
        request: (payload) => this._commissionerService.updateCommissioner(this.commissioner.id, payload!),

        onSend: () => {
            this.commissionerDetailsFormGroup.disable();
        },

        onSuccess: () => {
            this.commissionerDetailsFormGroup.enable();
            this._snackBar.open({
                colour: 'success',
                icon: 'check',
                title: 'General Information Updated'
            });
            this.dialogRef.close();
        },

        onError: () => {
            this.commissionerDetailsFormGroup.enable();
        }
    });

    update() {
        if (this.updateCommissionerRequest.loading()) {
            return;
        }

        const commissionerData: StoreCommissionerRequest = {
            reference: this.commissionerDetailsFormGroup.get('reference')?.value ?? '',
            name: this.commissionerDetailsFormGroup.get('name')?.value ?? '',
            email: this.commissioner.email,
            mandatory_documents: this.commissionerDetailsFormGroup.get('mandatory_documents')?.value ?? false
        };

        this.updateCommissionerRequest.send(commissionerData);
    }

    public static show(dialog: DialogService, data: Commissioner) {
        return dialog.openDialog<DialogRef, Commissioner>(EditCommissionerGeneralInformationDialogComponent, {
            data
        });
    }
}
